import React, { FC } from 'react';
import { ImageSection } from 'components/energy5/structures';
import { allSetImage } from 'assets/images/led-landing';
import useI18n from "evcharging/hooks/useI18n";

const ConfirmSelectionSection: FC = () => {
  const { t } = useI18n();

  return (
    <ImageSection
      title={t('landing.all-set.title')}
      text={t('landing.all-set.description')}
      imageSrc={allSetImage}
      width={1200}
      height={676}
      showBlueBgEffect
      imageBigLg
      imageLeft
      setImageBorder
    />
  );
};

export default ConfirmSelectionSection;
